// EventForm.tsx
import React from "react";

import { Event } from "0.Mine/3.Interfaces/Event";
import { UserLicense } from "0.Mine/3.Interfaces/license";

import { useEventFormLogic } from "../Logic/EventForm";
import { EventFormUI } from "../UI/EventFormUI";

interface EventFormProps {
  event: Event;
  isEdit: boolean;
  onSave: (event: Event) => void;
  onCancel: () => void;
  users: UserLicense[];
}

export const EventForm: React.FC<EventFormProps> = ({ users, event, isEdit, onSave, onCancel }) => {
  const {
    formData,
    handleChange,
    handleCheckboxChange,
    handleStartDateChange,
    handleEndDateChange,
    handleSubmit,
    styles,
  } = useEventFormLogic(event, onSave);

  return (
    <EventFormUI
      event={event}
      onSave={onSave}
      handleCheckboxChange={handleCheckboxChange}
      formData={formData}
      isEdit={isEdit}
      onCancel={onCancel}
      handleChange={handleChange}
      handleStartDateChange={handleStartDateChange}
      handleEndDateChange={handleEndDateChange}
      handleSubmit={handleSubmit}
      styles={styles}
      users={users}
    />
  );
};

export default EventForm;
